export default __webpack_public_path__ + "static/media/bell1.b4a57812.svg";